<template>
  <BlockUI :blocked="proc">
    <ol class="breadcrumb">
      <router-link to="/" class="breadcrumb-item"> Dashboard </router-link>
      <router-link to="/settledGames" class="breadcrumb-item textdecorationnone">
        <span class="colorbase">Settled Matches</span>
      </router-link>
      <router-link to="/profitandloss" class="breadcrumb-item">
        <span>Profit & Loss</span>
      </router-link>
      <router-link to="/statement" class="breadcrumb-item">
        <span>My Stmt.</span>
      </router-link>
      <router-link to="/ledgers" class="breadcrumb-item">
        <span>Company Ledgers</span>
      </router-link>
      <router-link to="/collectionReport" class="breadcrumb-item">
        <span>Collection Report</span>
      </router-link>
      <router-link to="/liveGames" class="breadcrumb-item">
        <span>Live Matches</span>
      </router-link>
    </ol>
    <div class="row">
      <div class="col-sm-12 col-md-6">
        <MultiSelect v-model="sel" :options="sps" optionLabel="b" placeholder="Select Sports" style="width: 100%" />
      </div>
      <div class="col-sm-12 col-md-6" style="height: 48px !important">
        <Datepicker v-model="date" range style="width: 100%" maxRange="60" :presetRanges="presetRanges" :datePicker="true" :max-date="maxd" :dark="true" auto-apply teleport-center>
          <template #yearly="{ label, range, presetDateRange }">
            <span @click="presetDateRange(range)">{{ label }}</span>
          </template>
        </Datepicker>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="d-grid gap-2">
          <Button label="Load" class="btn btn-grd btn-grd-deep-blue btn-sm" v-on:click="getpl()" />
        </div>
      </div>
    </div>
    <div class="accordion" id="accordionExample" v-if="pls.P !== undefined && pls.P.length > 0">
      <div class="accordion-item">
        <h2 class="accordion-header" id="headingOne">
          <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">Selected Total {{ pls.T1.toLocaleString() }}</button>
        </h2>
        <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <table class="table table-bordered table-hover">
              <thead>
                <tr>
                  <th>Sport</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="pl in currenttotal" :key="pl.S">
                  <td>
                    <div class="d-flex align-items-center gap-3">
                      <div class="">
                        <img :src="'/img/lordlotus/4.png'" alt="" width="20" v-if="pl.S === 'Cricket'" />
                        <img :src="'/img/lordlotus/1.png'" alt="" width="20" v-if="pl.S === 'Soccer'" />
                        <img :src="'/img/lordlotus/2.png'" alt="" width="20" v-if="pl.S === 'Tennis'" />
                        <img :src="'/img/lordlotus/7.png'" alt="" width="20" v-if="pl.S === 'Horse Racing'" />
                        <img :src="'/img/lordlotus/4339.png'" alt="" width="20" v-if="pl.S === 'Greyhound Racing'" />
                      </div>
                      <h6 class="mb-0 text-wrap">{{ pl.S }}</h6>
                    </div>
                    <!-- <Chip :label="pl.S" :image="'/img/lordlotus/4.png'" v-if="pl.S === 'Cricket'" style="width: 100%" />
                    <Chip :label="pl.S" :image="'/img/lordlotus/1.png'" v-if="pl.S === 'Soccer'" style="width: 100%" />
                    <Chip :label="pl.S" :image="'/img/lordlotus/2.png'" v-if="pl.S === 'Tennis'" style="width: 100%" />
                    <Chip :label="pl.S" :image="'/img/lordlotus/7.png'" v-if="pl.S === 'Horse Racing'" style="width: 100%" />
                    <Chip :label="pl.S" :image="'/img/lordlotus/4339.png'" v-if="pl.S === 'Greyhound Racing'" style="width: 100%" />
                    <Chip :label="pl.S" :image="'/img/lordlotus/Casino.jpg'" v-if="pl.S !== 'Cricket' && pl.S !== 'Soccer' && pl.S !== 'Tennis' && pl.S !== 'Horse Racing' && pl.S !== 'Greyhound Racing'" style="width: 100%" /> -->
                  </td>
                  <td class="text-right">
                    <h6 class="mb-0" :class="{ 'text-success': pl.T >= 0, 'text-danger': pl.T < 0 }">{{ pl.T.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</h6>
                    <!-- <Chip :label="pl.T.toLocaleString()" icon="pi pi-times" v-if="pl.T < 0" class="text-danger" />
                    <Chip :label="pl.T.toLocaleString()" icon="pi pi-check" v-if="pl.T > 0" class="text-success" /> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="accordion-item">
        <h2 class="accordion-header" id="headingtwo">
          <button class="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">All Time Total {{ ptotal.toLocaleString() }}</button>
        </h2>
        <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingtwo" data-bs-parent="#accordionExample">
          <div class="accordion-body">
            <table class="table table-bordered table-hover">
              <thead>
                <tr>
                  <th>Sport</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="pl in pls.P" :key="pl.S">
                  <td>
                    <div class="d-flex align-items-center gap-3">
                      <div class="">
                        <img :src="'/img/lordlotus/4.png'" alt="" width="20" v-if="pl.S === 'Cricket'" />
                        <img :src="'/img/lordlotus/1.png'" alt="" width="20" v-if="pl.S === 'Soccer'" />
                        <img :src="'/img/lordlotus/2.png'" alt="" width="20" v-if="pl.S === 'Tennis'" />
                        <img :src="'/img/lordlotus/7.png'" alt="" width="20" v-if="pl.S === 'Horse Racing'" />
                        <img :src="'/img/lordlotus/4339.png'" alt="" width="20" v-if="pl.S === 'Greyhound Racing'" />
                      </div>
                      <h6 class="mb-0 text-wrap">{{ pl.S }}</h6>
                    </div>
                    <!-- <Chip :label="pl.S" :image="'/img/lordlotus/4.png'" v-if="pl.S === 'Cricket'" style="width: 100%" />
                    <Chip :label="pl.S" :image="'/img/lordlotus/1.png'" v-if="pl.S === 'Soccer'" style="width: 100%" />
                    <Chip :label="pl.S" :image="'/img/lordlotus/2.png'" v-if="pl.S === 'Tennis'" style="width: 100%" />
                    <Chip :label="pl.S" :image="'/img/lordlotus/7.png'" v-if="pl.S === 'Horse Racing'" style="width: 100%" />
                    <Chip :label="pl.S" :image="'/img/lordlotus/4339.png'" v-if="pl.S === 'Greyhound Racing'" style="width: 100%" />
                    <Chip :label="pl.S" :image="'/img/lordlotus/Casino.jpg'" v-if="pl.S !== 'Cricket' && pl.S !== 'Soccer' && pl.S !== 'Tennis' && pl.S !== 'Horse Racing' && pl.S !== 'Greyhound Racing'" style="width: 100%" /> -->
                  </td>
                  <td class="text-right">
                    <h6 class="mb-0" :class="{ 'text-success': pl.T >= 0, 'text-danger': pl.T < 0 }">{{ pl.T.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</h6>
                    <!-- <Chip :label="pl.T.toLocaleString()" icon="pi pi-times" v-if="pl.T < 0" class="text-danger" />
                    <Chip :label="pl.T.toLocaleString()" icon="pi pi-check" v-if="pl.T > 0" class="text-success" /> -->
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="table-responsive" v-if="pls.D !== undefined && pls.D.length > 0">
      <h4>Sports</h4>
      <table class="table table-bordered table-responsive" id="earning-report-pdf" cellspacing="0" width="100%" v-if="getw > 767">
        <thead>
          <tr>
            <!-- <th>Match Id</th> -->
            <th>Match Title</th>
            <th class="text-end">Match Earnings</th>
            <th>Start</th>
            <th>End</th>
            <th>Winner</th>
          </tr>
        </thead>
        <tbody v-if="pls.D">
          <tr v-for="pl in pls.D" :key="pl.I">
            <!-- <td>{{ pl.I }}</td> -->
            <td>
              <router-link :to="'/settledgamedetails/' + pl.I + '/' + pl.E + '/' + pl.Sp">
                <div class="d-flex align-items-center gap-3">
                  <div class="">
                    <img :src="'/img/lordlotus/4.png'" alt="" width="20" v-if="pl.Sp === 'Cricket'" />
                    <img :src="'/img/lordlotus/1.png'" alt="" width="20" v-if="pl.Sp === 'Soccer'" />
                    <img :src="'/img/lordlotus/2.png'" alt="" width="20" v-if="pl.Sp === 'Tennis'" />
                    <img :src="'/img/lordlotus/7.png'" alt="" width="20" v-if="pl.Sp === 'Horse Racing'" />
                    <img :src="'/img/lordlotus/4339.png'" alt="" width="20" v-if="pl.Sp === 'Greyhound Racing'" />
                  </div>
                  <h6 class="mb-0 text-wrap">{{ pl.E }}</h6>
                </div>
              </router-link>
              <!-- <router-link :to="'/settledgamedetails/' + pl.I + '/' + pl.E + '/' + pl.Sp">
                <Chip :label="pl.E" :image="'/img/lordlotus/4.png'" v-if="pl.Sp === 'Cricket'" style="width: 100%" />
                <Chip :label="pl.E" :image="'/img/lordlotus/1.png'" v-if="pl.Sp === 'Soccer'" style="width: 100%" />
                <Chip :label="pl.E" :image="'/img/lordlotus/2.png'" v-if="pl.Sp === 'Tennis'" style="width: 100%" />
                <Chip :label="pl.E" :image="'/img/lordlotus/7.png'" v-if="pl.Sp === 'Horse Racing'" style="width: 100%" />
                <Chip :label="pl.E" :image="'/img/lordlotus/4339.png'" v-if="pl.Sp === 'Greyhound Racing'" style="width: 100%" />
              </router-link> -->
            </td>
            <td class="text-end">
              <h6 class="mb-0" :class="{ 'text-success': pl.T >= 0, 'text-danger': pl.T < 0 }">{{ pl.T.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</h6>
              <!-- <Chip :label="pl.T.toLocaleString()" icon="pi pi-times" v-if="pl.T < 0" class="text-danger" />
              <Chip :label="pl.T.toLocaleString()" icon="pi pi-check" v-if="pl.T > 0" class="text-success" /> -->
            </td>
            <td>
              <h6>{{ pl.D }}</h6>
              <!-- <Chip :label="pl.D" icon="pi pi-play" /> -->
            </td>
            <td>
              <h6>{{ pl.D1 }}</h6>
              <!-- <Chip :label="pl.D1" icon="pi pi-stop-circle" /> -->
            </td>
            <td>
              <h6>{{ winner[pl.I] }}</h6>
              <!-- <Chip :label="winner[pl.I]" icon="" /> -->
            </td>
          </tr>
        </tbody>
      </table>
      <div class="list-group" v-if="getw < 767">
        <router-link :to="'/settledgamedetails/' + pl.I + '/' + pl.E + '/' + pl.Sp" class="text-white mb-2" v-for="pl in pls.D" :key="pl.I">
          <div class="d-flex flex-column gap-4">
            <div class="d-flex gap-3">
              <div class="social-icon d-flex align-items-center gap-3 flex-grow-1">
                <img :src="'/img/lordlotus/4.png'" alt="" width="20" v-if="pl.Sp === 'Cricket'" />
                <img :src="'/img/lordlotus/1.png'" alt="" width="20" v-if="pl.Sp === 'Soccer'" />
                <img :src="'/img/lordlotus/2.png'" alt="" width="20" v-if="pl.Sp === 'Tennis'" />
                <img :src="'/img/lordlotus/7.png'" alt="" width="20" v-if="pl.Sp === 'Horse Racing'" />
                <img :src="'/img/lordlotus/4339.png'" alt="" width="20" v-if="pl.Sp === 'Greyhound Racing'" />
                <div>
                  <h6 class="mb-0 text-wrap">{{ pl.E }}</h6>
                  <p class="mb-0">{{ pl.D }}</p>
                  <p class="mb-0">{{ pl.D1 }}</p>
                  <p class="mb-0">Winner {{ winner[pl.I] }}</p>
                </div>
              </div>
              <h6 class="mb-0" :class="{ 'text-success': pl.T1 >= 0, 'text-danger': pl.T1 < 0 }">{{ pl.T1.toLocaleString(undefined, { minimumFractionDigits: 2 }) }}</h6>
              <!-- <div class="card-lable bg-success text-success bg-opacity-10">
                <p class="text-success mb-0">+28.5%</p>
              </div> -->
            </div>
          </div>
        </router-link>
        <!-- <router-link :to="'/settledgamedetails/' + pl.I + '/' + pl.E + '/' + pl.Sp" class="list-group-item list-group-item-action d-flex align-items-center text-white" v-for="pl in pls.D" :key="pl.I">
          <div class="w-60px h-60px d-flex align-items-center justify-content-center ms-n1 bg-white p-1">
            <img src="/img/lordlotus/4.png" alt="" class="mw-100 mh-100" v-if="pl.Sp === 'Cricket'" />
            <img src="/img/lordlotus/1.png" alt="" class="mw-100 mh-100" v-if="pl.Sp === 'Soccer'" />
            <img src="/img/lordlotus/2.png" alt="" class="mw-100 mh-100" v-if="pl.Sp === 'Tennis'" />
            <img src="/img/lordlotus/7.png" alt="" class="mw-100 mh-100" v-if="pl.Sp === 'Horse Racing'" />
            <img src="/img/lordlotus/4339.png" alt="" class="mw-100 mh-100" v-if="pl.Sp === 'Greyhound Racing'" />
          </div>
          <div class="flex-fill px-3">
            <div class="fw-bold">{{ pl.E }}&nbsp;<i class="fa-solid fa-eye"></i></div>
            <div class="small text-white text-opacity-50">Match Id : {{ pl.I }}</div>
            <div class="small text-white text-opacity-50">Start : {{ pl.D }}</div>
            <div class="small text-white text-opacity-50">End : {{ pl.D1 }}</div>
            <div class="small text-white text-opacity-50">Winner : {{ winner[pl.I] }}</div>
          </div>
          <div>
            <span class="badge bg-transparent border fs-12px fw-500 rounded-sm" :class="{ 'border-theme1 text-theme1': pl.T < 0, 'border-theme text-theme': pl.T >= 0 }"> {{ pl.T.toLocaleString() }} </span>
          </div>
        </router-link> -->
      </div>
    </div>
    <div class="table-responsive" v-if="pls.C !== undefined && pls.C.length > 0">
      <h4>Casino</h4>
      <table class="table table-bordered table-striped" id="earning-report-pdf" cellspacing="0" width="100%" v-if="getw > 767">
        <thead>
          <tr>
            <th>Casino Id</th>
            <th>Casino Title</th>
            <th class="text-right">Casino Earnings</th>
            <th>Start</th>
            <th>End</th>
          </tr>
        </thead>
        <tbody v-if="pls.C">
          <tr v-for="pl in pls.C" :key="pl.I" v-on:click="getd(pl)">
            <td>{{ pl.I }}</td>
            <td>
              <Chip :label="pl.E" :image="'/img/lordlotus/Casino.jpg'" style="width: 100%" />
            </td>
            <td class="text-right">
              <Chip :label="pl.T.toLocaleString()" icon="pi pi-times" v-if="pl.T < 0" class="text-danger" />
              <Chip :label="pl.T.toLocaleString()" icon="pi pi-check" v-if="pl.T > 0" class="text-success" />
            </td>
            <td><Chip :label="pl.D" icon="pi pi-play" /></td>
            <td><Chip :label="pl.D1" icon="pi pi-stop-circle" /></td>
          </tr>
        </tbody>
      </table>
      <div class="list-group" v-if="getw < 767">
        <a href="javascript:void(0);" class="list-group-item list-group-item-action d-flex align-items-center text-white" v-for="pl in pls.C" :key="pl.I" v-on:click="getd(pl)">
          <div class="w-60px h-60px d-flex align-items-center justify-content-center ms-n1 bg-white p-1">
            <img src="/img/lordlotus/Casino.jpg" alt="" class="mw-100 mh-100" />
          </div>
          <div class="flex-fill px-3">
            <div class="fw-bold">{{ pl.E }}&nbsp;<i class="fa-solid fa-eye"></i></div>
            <div class="small text-white text-opacity-50">Match Id : {{ pl.I }}</div>
            <div class="small text-white text-opacity-50">Start : {{ pl.D }}</div>
            <div class="small text-white text-opacity-50">End : {{ pl.D1 }}</div>
          </div>
          <div>
            <span class="badge bg-transparent border fs-12px fw-500 rounded-sm" :class="{ 'border-theme1 text-theme1': pl.T < 0, 'border-theme text-theme': pl.T >= 0 }"> {{ pl.T.toLocaleString() }} </span>
          </div>
        </a>
      </div>
    </div>
  </BlockUI>
</template>

<script>
import $$vm from "@/data/index";
import MultiSelect from "primevue/multiselect";
import Datepicker from "@vuepic/vue-datepicker";
import Dropdown from "primevue/dropdown";
import Button from "primevue/button";
import BlockUI from "primevue/blockui";
import Chip from "primevue/chip";
import Dialog from "primevue/dialog";
import DataTable from "primevue/datatable";
import Column from "primevue/column";

import { endOfMonth, endOfYear, startOfMonth, startOfYear, subMonths, add, endOfWeek, subWeeks, startOfWeek, setDefaultOptions } from "date-fns";

export default {
  name: "SettledGames",
  components: {
    MultiSelect,
    Datepicker,
    Dropdown,
    Button,
    BlockUI,
    Chip,
    Dialog,
    DataTable,
    Column,
  },
  data() {
    return {
      proc: false,
      page: 0,
      size: 50,
      total: 0,
      gtotal: 0,
      ptotal: 0,
      pls: {},
      dts: [],
      dtssc: false,
      dtshd: "",
      dtssp: "",
      dtswn: "",
      getw: 0,
      sp: "",
      maximum: true,
      showpl: false,
      showpl1: false,
      cpld: {},
      cpld1: {},
      cpldall: [],
      cpldallid: 0,
      showbets: false,
      bets: {},
      showip: false,
      showdevice: false,
      did: "",
      ip: "",
      name: "",
      name1: "",
      // format: "dd-MM-yyyy - dd-MM-yyyy",
      cities: [
        { name: "Today", code: "T" },
        { name: "Yesterday", code: "Y" },
        { name: "Last 7 Days", code: "L7D" },
        { name: "This Week", code: "TW" },
        { name: "Last Week", code: "LW" },
        { name: "Last 30 Days", code: "L30D" },
        { name: "This Month", code: "TM" },
        { name: "Last Month", code: "LM" },
      ],
      sel: [
        { b: "Cricket", value: "Cricket" },
        { b: "Soccer", value: "Soccer" },
        { b: "Tennis", value: "Tennis" },
        { b: "Horse Racing", value: "Horse Racing" },
        { b: "Greyhound Racing", value: "Greyhound Racing" },
        //{ b: "Casino", value: "Casino" },
      ],
      sps: [
        { b: "Cricket", value: "Cricket" },
        { b: "Soccer", value: "Soccer" },
        { b: "Tennis", value: "Tennis" },
        { b: "Horse Racing", value: "Horse Racing" },
        { b: "Greyhound Racing", value: "Greyhound Racing" },
        //{ b: "Casino", value: "Casino" },
      ],
      startdate: new Date(),
      enddate: new Date(),
      maxd: new Date(),
      date: [],
      presetRanges: [
        { label: "Today", range: [new Date(), new Date()] },
        { label: "Yesterday", range: [add(new Date(), { days: -1 }), add(new Date(), { days: -1 })] },
        { label: "Last 7 Days", range: [add(new Date(), { days: -6 }), new Date()] },
        { label: "This Week", range: [startOfWeek(new Date(), { weekStartsOn: 1 }), new Date()] },
        { label: "Last Week", range: [startOfWeek(subWeeks(new Date(), 1), { weekStartsOn: 1 }), endOfWeek(subWeeks(new Date(), 1), { weekStartsOn: 1 })] },
        { label: "Last 30 Days", range: [add(new Date(), { days: -29 }), new Date()] },
        { label: "This month", range: [startOfMonth(new Date()), endOfMonth(new Date())] },
        {
          label: "Last month",
          range: [startOfMonth(subMonths(new Date(), 1)), endOfMonth(subMonths(new Date(), 1))],
        },
        { label: "This year", range: [startOfYear(new Date()), endOfYear(new Date())] },
      ],
      currenttotal: [],
      winner: {},
    };
  },
  mounted() {
    var self = this;
    //self.enddate = new Date(2023,2,30);
    //self.startdate = new Date(2023,2,28);
    self.date = [this.startdate, this.enddate];
    self.update();
    self.getw = $(window).width();
    $(window).resize(function () {
      self.getw = $(window).width();
    });
  },
  methods: {
    update: function () {
      var self = this;
      self.maxd = new Date();
      if (self.$route.params.id !== undefined && self.$route.params.id !== self.name1) {
        self.name1 = self.$route.params.id;
        self.getpl();
      }
      setTimeout(function () {
        self.update();
      }, 1000);
    },
    getpl: function () {
      var self = this;
      if (self.sel.length === 0) {
        toastr["error"]("Please Select Sport");
        return;
      }
      self.sp = "";
      self.sel.forEach((el) => {
        self.sp += el.value + ",";
      });
      var cd = new Date();
      if (self.enddate > cd) {
        self.enddate = cd;
      }
      if (self.enddate < self.startdate) {
        self.enddate = self.startdate;
      }
      self.startdate = self.date[0];
      self.enddate = self.date[1];
      var from = self.startdate.getFullYear() + "-" + (self.startdate.getMonth() + 1) + "-" + self.startdate.getDate() + " 00:00";
      var to = self.enddate.getFullYear() + "-" + (self.enddate.getMonth() + 1) + "-" + self.enddate.getDate() + " 23:59";
      if ($$vm.cn) {
        self.pls = {};
        self.total = 0;
        self.proc = true;
        self.currenttotal = [];
        self.winner = {};
        $$vm.c.invoke("getplbsf", self.sp, from, to, (self.page * self.size).toString(), self.size.toString(), self.name1).then(
          function (data) {
            data = $$vm.decompress(data);
            self.pls = data;
            self.total = data.T;
            $.each(self.pls.D, function (ii, jj) {
              var sp = jj["Sp"];
              var isfound = false;
              $.each(self.currenttotal, function (key, val) {
                if (val["S"] === sp) {
                  isfound = true;
                  val["T"] = val["T"] + jj["T1"];
                }
              });
              if (!isfound) {
                self.currenttotal.push({ S: sp, T: jj["T1"] });
              }
              jj["D"] = moment($$vm.cutl3(jj["D"])).format("DD/MM/YYYY HH:mm:ss");
              jj["D1"] = moment($$vm.cutl3(jj["D1"])).format("DD/MM/YYYY HH:mm:ss");
            });
            self.proc = false;
            self.ptotal = 0;
            var sps = self.sp.split(",");
            $.each(sps, function (oo, pp) {
              if (pp.length > 0) {
                $.each(self.pls.P, function (oo1, pp1) {
                  if (pp1.S === pp || (pp === "Cricket" && pp1.S === "Fancy")) {
                    self.ptotal += pp1["T"];
                  } else if ((pp1.S === "JackLobby" || pp1.S === "Ezugi" || pp1.S === "Evolution") && pp === "Casino") {
                    self.ptotal += pp1["T"];
                  }
                });
              }
            });
            $.each(self.pls.W, function (ii, jj) {
              self.winner[jj["I"]] = jj["W"];
            });
          },
          function (err) {
            self.proc = false;
          }
        );
      } else {
        setTimeout(function () {
          self.getpl();
        }, 1000);
        //toastr["error"]("Not Connected to Server");
      }
    },
  },
};
</script>

<style></style>
